import DeliveryDatePicker from "components/Date/DeliveryDatePicker"
import React, { Component } from "react"
import { observer } from "mobx-react"
import { Link } from "react-router-dom"
{/*ELEM REACT16 CHANGE */}
import { Header, Button, Modal, Dropdown , FormField, FormInput, Card} from "semantic-ui-react"
import shop from "shop/shop"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import moment from "moment"

window.moment = moment
import "style/DeliveryPage.scss"
import 'react-day-picker/lib/style.css';


@observer
export default class DeliveryPageCoupon extends Component {
  
  state = {
    uploadedImages  : [],
    locations       : [],
    locationSelected: null,
    comment         : "",
    modalOpened     : false,
    tempAddressIndex: 0,
    tempAddress     : {
      mapid   : "0",
      name1   : "",
      name2   : "",
      name3   : "",
      street  : "",
      pcode   : "",
      city    : "",
      country : "",
      company : "",
      addition: "",
    }
  }
  
  handleAddressChoice = () => {
    const tempAddress = this.state.tempAddress
    const nextTempAddressIndex = this.state.tempAddressIndex + 1
    
    shop.cart.setAddress( { location: tempAddress } )
    
    this.setState( {
      locations       : [tempAddress, ...this.state.locations],
      locationSelected: tempAddress.mapid,
      modalOpened     : false,
      tempAddressIndex: nextTempAddressIndex,
      tempAddress     : {
        mapid   : `tempAddress${nextTempAddressIndex}`,
        company : "",
        name1   : "",
        name2   : "",
        name3   : "",
        street  : "",
        pcode   : "",
        city    : "",
        country : "",
        addition: "",
      }
    } )
  }
  
  toggleModal = ( toggle = false ) => {
    this.setState( { modalOpened: toggle } )
  }
  
  handleAddressFieldChange = ( evt ) => {
    const tempAddress = this.state.tempAddress
    tempAddress[ evt.target.name ] = evt.target.value
    this.setState( { tempAddress } )
  }
  
  handleLocationSelect = ( location ) => {
    console.log( `set`, location )
    this.setState( { locationSelected: location.mapid } )
    shop.cart.setAddress( { location } )
  }
  
  handleOrderIdChange = ( event ) => {
    let manual_order_id = event.target.value
    this.setState( { manual_order_id } )
    shop.cart.setExtra( "manual_order_id", manual_order_id )
  }
  
  handleCommentChange = ( event ) => {
    let comment = event.target.value
    this.setState( { comment } )
    shop.cart.setComment( { comment } )
  }
  
  handleDateChange = ( date ) => {
    let deliverdate = moment( date )
    if ( deliverdate.isValid() ) {
      deliverdate = deliverdate.format( "DD.MM.YYYY" )
      this.setState( { deliverdate } )
      shop.cart.setDeliverdate( { deliverdate } )
    } else {
      shop.cart.setDeliverdate( ({ deliverdate: "" }) )
      this.setState( { deliverdate: "" } )
    }
    
  }
  
  updateCart = ( { cart } ) => {
    let locationSelected = cart.data.deliveraddress && cart.data.deliveraddress.mapid
    if ( locationSelected ) {
      this.setState( { locationSelected } )
    }
  }
  
  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }
  
  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
    
    // let ok = checkCartSize()
    // ok = ok && checkMinCartValue()
    // if ( !ok ) return
    
    if ( shop.cart.data.deliveraddress && shop.cart.data.deliveraddress.mapid ) {
      let locationSelected = shop.cart.data.deliveraddress.mapid
      this.setState( { locationSelected } )
    }
    
    shop.fetch( "/shop/rest/data/customers/current/addresses/deliver" )
      .then( locations => {
        console.log( "LOCATIONS!", locations.length, { locations } )
        
        if ( locations.length < 1 ) {
          console.info( "Keine Versandadressen vorhanden" )
          return
        }
        
        let locationSelected = this.state.locationSelected
        const shortlist = locations.slice( 0, 5 )
        this.setState( {
          locations,
          shortlist,
          locationSelected
        } )
      } )
      if(shop.cart.activeCoupons.length > 0){
        this.props.history.push("/checkoutCpn/checkout")
        document.location.reload()
      }
  }
  
  render() {
    let { uploadedImages, locations, shortlist, locationSelected, tempAddress, modalOpened } = this.state
    const attachments = shop.cart.getExtra( "attachments" )
    const deliveryLocation = locations.filter( loc => loc.mapid === locationSelected )
    let { comment, deliveraddress, deliverdate, print_receipt, comment_internal } = shop.cart.data
    let { manual_order_id } = shop.cart.data.extras
    let billingAddress = shop.session.value || {}
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    const { hasDeliveryAddress } = shop.cart
    return (
      <div className="pb5">
        {/*HEADER STATE*/}
        {this.props.children}
        <HeaderCheckout activeStep={1} isRequest={isRequest}/>
        
        <section className="container">
          
          <div className="row-title tl">
            <h2>{translate( "your data" )}</h2>
          </div>
          <tr>
            
            <td md="1/5" className=""><span className="black-50">{translate( "billing address" )}</span>
              <div className="pt3">
                <strong> {billingAddress.title}</strong> <br/>
                {billingAddress.street} <br/>
                {billingAddress.pcode} {billingAddress.city}<br/>
                {billingAddress.country}<br/>
                {billingAddress.email && <div>{billingAddress.email}</div>}
                {billingAddress.phone && <div>{billingAddress.phone}</div>}
              </div>
            </td>
            <td md="1/5" className=""><span className="black-50">{translate( "delivery address" )} </span>
              <div className="pt3">
                {!hasDeliveryAddress && <div className={"b"}>{translate( "billing address" )}</div>}
                {deliveraddress && <div>
                  <div className="mb4">
                    <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                    {deliveraddress.street}<br/>
                    {deliveraddress.pcode} {deliveraddress.city}<br/>
                    {deliveraddress.country}<br/>
                    
                    <div className="pt3 f6">
                      {deliveraddress.email && <div>{deliveraddress.email}</div>}
                      {deliveraddress.phone && <div>Tel.: {deliveraddress.phone}</div>}
                    </div>
                  </div>
                </div>}
              </div>
            </td>
            {/*<td md="1/5" className=""><span className="black-50">{translate( "payment" )} </span>*/}
            {/*  <div className="pt3">*/}
            {/*    <strong>wie vereinbart</strong>*/}
            {/*  </div>*/}
            {/*</td>*/}
            <td md="1/5" className=""><span className="black-50">{translate( "your message" )}
              <div className="pt3">
                  <p className="mb4">{comment ? comment : "-"}</p>
              </div>
              </span></td>
          </tr>
        
        </section>
        
        <section className="container pt4 pb4">
          <div className="row-title tl">
            <h2>{translate( "your addresses" )}</h2>
          </div>
          
          {shop.config.checkoutFeatures.temporaryDeliveryAddress &&
          <div className="pb3">
            <TemporaryAddress
              temporaryAddress={shop.cart.data.deliveraddress}
              onSubmit={( address ) => {
                shop.cart.setDeliverAddress( address )
                this.setState( { locationSelected: false } )
                shop.toast(translate("Lieferadresse ausgewählt") + ` – ${address.pcode} ${address.city}`, "success")
              }}/>
          </div>}
          
          {locations.length > 10 ? <div>
            <Adresses onChange={this.handleLocationSelect}
                      locations={shortlist}
                      deliveryLocation={deliveryLocation}
                      locationSelected={locationSelected}/>
            <div><Link to="/checkout/delivery/addresses">{translate("Alle Adressen anzeigen")}</Link>
            </div>
          </div> : <Adresses onChange={this.handleLocationSelect}
                             locations={locations}
                             locationSelected={locationSelected}/>
          }
        
        </section>
        
        <section className="container">
          <tr>
            <td sm="2/3">
              <FormField label={translate( "comment" )}
                         htmlFor="supported-controls-input">
                <FormInput placeholder={translate( "comment" )}
                           value={comment}
                           onChange={this.handleCommentChange}
                           multiline/>
              </FormField>
            </td>
          </tr>
        </section>
        
        
        {shop.config.checkoutFeatures.manualOrderId &&
        <section className="container">
          <div className="mw6">
            
            <FormField label={translate( "order number" )}>
              <FormInput placeholder={translate( "order number" )}
                         value={manual_order_id}
                         onChange={this.handleOrderIdChange}
              />
            </FormField>
          
          </div>
        </section>
        }
        
        
        {/*DELIVERY DATE SUGGESTION*/}
        {(shop.config.checkoutFeatures.deliverdate || shop.config.plugin.deliverdate) &&
        <section className="container">
          {/*COMMENT WITH UPLOAD */}
          {/*NORMAL COMMENT*/}
          
          <tr>
            <td sm="2/3">
              <FormField label={translate( "delivery after" )}
                         htmlFor="supported-controls-input">
                <DeliveryDatePicker date={deliverdate} onChange={this.handleDateChange}/>
              </FormField>
            </td>
          </tr>
        </section>
        }
        
        
        {/*ONLY FOR VERTRIEBSACCOUNTS*/}
        {(shop.session.handId && !shop.config.hideAddtionalCheckoutMetaForPowerUsers) && <div className="pt3">
          <section className="container">
            <div className="row-title tl">
              <h2>{translate( "back office" )}</h2>
            </div>
            <tr>
         
              <td sm="1/2">
                <FormField label={translate( "Belegausdruck/Innendienst" )}
                           htmlFor="supported-controls-input">
                  <FormInput placeholder={translate( "Belegausdruck/Innendienst" )}
                             value={print_receipt}
                             onChange={event => {
                               let print_receipt = event.target.value
                               shop.cart.setExtra( "print_receipt", print_receipt )
                             }}
                             multiline/>
                </FormField>
              </td>
            </tr>
          </section>
        </div>}
        
        <section className="pa2 mb4 ">
          <div className="container">
            <tr>
              <td xs="1/2"
                   className="tl fl checkout-control">
                <Link to={{ pathname: "..", search: this.props.location.search }}>
                  <Button>
                    <i className="icon-angle-left"/>
                    {translate( "Zurück" )}
                  </Button>
                </Link>
              </td>
              
              <td xs="1/2"
                   className="tr fr checkout-control">
                <Link to={{
                  pathname: "../confirmation",
                  search  : this.props.location.search
                }}>
                  <Button primary>
                    {translate( "Weiter" )}
                    <i className="icon-angle-right"/>
                  </Button>
                </Link>
              </td>
            </tr>
          </div>
        </section>
      </div>
    )
  }
}

const Adress = ( { location, handleSelect, isSelected } ) => {
  return (
    <div>
      <h3>{location.mapid.indexOf( "tempAddress" ) !== -1 && "Eingegebene"} {translate( "Adresse" )}</h3>
      {location.company} <br/>
      {location.name1} {location.name2} {location.name3}<br/>
      {location.street} <br/>
      {location.addition} <br/>
      {location.pcode} {location.city}<br/>
      {location.country}<br/>
      {location.extras && <React.Fragment>
        {location.extras.ShipmentMethodCodeText && <div>{location.extras.ShipmentMethodCodeText}</div>}
      </React.Fragment>}
      <div className="pt3">
        {isSelected ?
          <Button size="small" primary onClick={() => handleSelect( false )} icon={"check"}/> :
          <Button size="small" basic onClick={() => handleSelect( location )}>{translate( "auswählen" )}</Button>
        }
      </div>
      {/*<pre>{JSON.stringify(location, null, 2)}</pre>*/}
    </div>
  )
}

const Adresses = ( { locations, locationSelected, onChange, deliveryLocation } ) => {
  let addresses = locations.map( ( location, key ) => {
    // console.log( `${locationSelected} == ${location.mapid}` )
    let isSelected = locationSelected == location.mapid
    if ( isSelected && deliveryLocation && deliveryLocation.mapid ) return null
    return (<td key={key} sm="1/3"><Card>
      <Adress isSelected={isSelected} handleSelect={onChange} location={location}/></Card>
    </td>)
  } )
  return <tr>
    {deliveryLocation && deliveryLocation.mapid && <td key="AB" sm="1/3"><Card>
      <Adress isSelected={true} handleSelect={onChange} location={deliveryLocation}/></Card>
    </td>}
    {addresses}</tr>
}

const TemporaryAddress = ( { onSubmit, temporaryAddress } ) => {
  const [open, setOpen] = React.useState( false )
  const [untouched, setUntouched] = React.useState( true )
  const [address, setAddress] = React.useState( false )
  return <div>
    <Button onClick={() => setOpen( true )}>{translate( "Neue Lieferadresse" )}</Button>
    <Modal open={open}>
      <Modal.Header>
        <div className="flex flex-row justify-between items-center">
          <div>{translate( "Lieferadresse" )}</div>
          <Button basic circular
                  onClick={() => {
                    setOpen( false )
                  }}
                  icon="times"
          />
        </div>
      
      </Modal.Header>
      <Modal.Content>
        <TemporaryAddressForm
          untouched={untouched}
          onChange={( address ) => {
            setAddress( address )
          }}/>
      </Modal.Content>
      <Modal.Actions>
        <Button basic type="link-cancel" onClick={() => setOpen( false )}>{translate( "schließen" )}</Button>
        <Button primary className="fr" onClick={() => {
          setUntouched( false )
          if ( !address.name1 ) return shop.toast( translate( "Bitte ausfüllen: Unternehmen" ) )
          // if ( !address.name2 ) return shop.toast( translate( "Bitte ausfüllen: Unternehmenszusatz" ) )
          if ( !address.street ) return shop.toast( translate( "Bitte ausfüllen: Straße" ) )
          if ( !address.city ) return shop.toast( translate( "Bitte ausfüllen: Stadt" ) )
          if ( !address.pcode ) return shop.toast( translate( "Bitte ausfüllen: Postleitzahl" ) )
          onSubmit( address )
          // TODO: VALIDATE
          setOpen( false )
        }
        } type="primary">{translate( "Adresse auswählen" )}</Button>
      </Modal.Actions>
    </Modal>
  </div>
  
  // return (
  //   <div>
  //     <Modal isOpen={modalOpened} onCancel={() => handleModal( false )} backdropClosesModal>
  //       <ModalHeader text={`Neue Adresse hinzufügen`} onClose={() => handleModal( false )}/>
  //       <ModalBody>
  //         <TemporaryAddressForm handleChange={handleChange} temporaryAddress={temporaryAddress}/>
  //       </ModalBody>
  //       <ModalFooter>
  //         <Button type="link-cancel" onClick={() => handleModal( false )}>schließen</Button>
  //         <Button className="fr" type="primary" onClick={() => handleAddressChoice()}>hinzufügen</Button>
  //       </ModalFooter>
  //     </Modal>
  //
  //     <tr>
  //       <td sm="1">
  //         <Button className="mt2" onClick={() => handleModal( true )}>temporäre Adresse hinzufügen</Button>
  //       </td>
  //     </tr>
  //   </div>
  // )
}

const TemporaryAddressForm = ( { onChange, untouched = true, temporaryAddress = {} } ) => {
  const [form, setForm] = React.useState( Object.assign( { extras: { freecontact: "" } }, temporaryAddress ) )
  const handleChange = ( event ) => {
    const name = event.currentTarget.name
    const value = event.currentTarget.value
    const newForm = { ...form, [ name ]: value }
    setForm( newForm )
    onChange && onChange( newForm )
  }
  
  return (
    <form className={`AddressForm TemporaryAddressForm ${untouched ? "untouched" : ""}`}>
      <tr>
        <td sm="1/3">
          <FormField label={translate( "Unternehmen" ) + "*"} htmlFor="name1">
            <FormInput maxLength={50} required type="text" name="name1" value={form.name1} onChange={handleChange}/>
          </FormField>
        </td>
        
        <td sm="1/3">
          <FormField label={translate( "Unternehmenszusatz" )} htmlFor="name2">
            <FormInput maxLength={50} type="text" name="name2" value={form.name2} onChange={handleChange}/>
          </FormField>
        </td>
        
        <td sm="1/3">
          <FormField label={translate( "Ansprechpartner" )} htmlFor="contact">
            <FormInput maxLength={50} type="text" name="freecontact" value={form.extras.freecontact} onChange={( event ) => {
              const name = event.currentTarget.name
              const value = event.currentTarget.value
              const newForm = { ...form, extras: { ...form.extras, [ name ]: value } }
              setForm( newForm )
              onChange && onChange( newForm )
              console.log( { newForm } )
            }}/>
          </FormField>
        </td>
      
      </tr>
      
      {/*<FormField label="Firma" htmlFor="company">*/}
      {/*  <tr>*/}
      {/*    <td sm="1">*/}
      {/*      <FormInput type="text" name="company" placeholder="Firma" value={form.company}*/}
      {/*                 onChange={handleChange}/>*/}
      {/*    </td>*/}
      {/*  </tr>*/}
      {/*</FormField>*/}
      
      <tr>
        <td sm="1">
          <FormField required label={translate( "Straße" ) + "*"} htmlFor="street">
            <FormInput required maxLength={50} type="text" name="street" placeholder="Straße" value={form.street}
                       onChange={handleChange}/>
          </FormField>
        </td>
      </tr>
      
      <tr>
        <td sm="1">
          <FormField label={translate( "Adresszusatz" )} htmlFor="addition">
            <FormInput maxLength={50} type="text" name="addition" placeholder="Adresszusatz"
                       value={form.addition}
                       onChange={handleChange}/>
          </FormField>
        </td>
      </tr>
      
      <tr>
        <td sm="1/5">
          <FormField maxLength={20} required label={translate( "PLZ" ) + "*"} htmlFor="pcode">
            <FormInput required type="text" name="pcode" placeholder="PLZ" value={form.pcode}
                       onChange={handleChange}/>
          </FormField>
        </td>
        <td sm="4/5">
          <FormField required label={translate( "Ort" ) + "*"} htmlFor="city">
            <FormInput required maxLength={30} type="text" name="city" placeholder={translate("Ort")} value={form.city}
                       onChange={handleChange}/>
          </FormField>
        </td>
      </tr>
      
      <FormField label="Land" htmlFor="country">
        <tr>
          <td sm="1">
            <Dropdown
              placeholder="Land"
              fluid
              search
              selection
              options={countryOptions}
              onChange={( e, { value } ) => {
                console.log( { value } )
                let fakeEvent = { currentTarget: { name: "country", value } }
                handleChange( fakeEvent )
              }}
            />
          
          </td>
        </tr>
      </FormField>
      
      <div className="pt3">
        <p className="f6 black-80">{translate( "Für Rückfragen des Lieferdienstes" )}:</p>
        
        <tr>
          <td sm="1/5">
            <FormField label="E-Mail" htmlFor="email">
              <FormInput maxLength={50} type="email" name="email" placeholder="E-Mail" value={form.email}
                         onChange={handleChange}/>
            </FormField>
          </td>
          <td sm="4/5">
            <FormField label="Telefon" htmlFor="phone">
              <FormInput maxLength={30} type="text" name="phone" placeholder="+49..." value={form.phone}
                         onChange={handleChange}/>
            </FormField>
          </td>
        </tr>
      </div>
    </form>
  )
}


const countryOptions = [
  ["AD", "Andorra"],
  ["AE", "United Arab Emirates"],
  ["AL", "Albania"],
  ["AM", "Armenia"],
  ["AO", "Angola"],
  ["AT", "Austria"],
  ["AU", "Australia"],
  ["AZ", "Azerbaijan"],
  ["BA", "Bosnia and Herzegovina"],
  ["BD", "Bangladesh"],
  ["BE", "Belgium"],
  ["BF", "Burkina Faso"],
  ["BG", "Bulgaria"],
  ["BH", "Bahrain"],
  ["BI", "Burundi"],
  ["BJ", "Benin"],
  ["BN", "Brunei Darussalam"],
  ["BR", "Brazil"],
  ["BT", "Bhutan"],
  ["BW", "Botswana"],
  ["BY", "Belarus"],
  ["CA", "Canada"],
  ["CH", "Switzerland"],
  ["CL", "Chile"],
  ["CN", "China"],
  ["CU", "Cuba"],
  ["CY", "Cyprus"],
  ["CZ", "Czechia"],
  ["DE", "Deutschland"],
  ["DK", "Denmark"],
  ["DO", "Dominican Republic"],
  ["DZ", "Algeria"],
  ["EE", "Estonia"],
  ["EG", "Egypt"],
  ["ES", "Spain"],
  ["FI", "Finland"],
  ["FJ", "Fiji"],
  ["FR", "France"],
  ["GB", "United Kingdom"],
  ["GE", "Georgia"],
  ["GG", "Guernsey"],
  ["GH", "Ghana"],
  ["GI", "Gibraltar"],
  ["GM", "Gambia"],
  ["GN", "Guinea"],
  ["GQ", "Equatorial Guinea"],
  ["GR", "Greece"],
  ["HK", "Hong Kong"],
  ["HR", "Croatia"],
  ["HU", "Hungary"],
  ["ID", "Indonesia"],
  ["IE", "Ireland"],
  ["IL", "Israel"],
  ["IM", "Isle of Man"],
  ["IN", "India"],
  ["IQ", "Iraq"],
  ["IR", "Iran"],
  ["IS", "Iceland"],
  ["IT", "Italy"],
  ["JE", "Jersey"],
  ["JO", "Jordan"],
  ["JP", "Japan"],
  ["KE", "Kenya"],
  ["KG", "Kyrgyzstan"],
  ["KR", "Republic of Korea"],
  ["KW", "Kuwait"],
  ["KZ", "Kazakhstan"],
  ["LB", "Lebanon"],
  ["LI", "Liechtenstein"],
  ["LK", "Sri Lanka"],
  ["LR", "Liberia"],
  ["LS", "Lesotho"],
  ["LT", "Lithuania"],
  ["LU", "Luxembourg"],
  ["LV", "Latvia"],
  ["LY", "Libya"],
  ["MA", "Morocco"],
  ["MC", "Monaco"],
  ["MD", "Moldova"],
  ["ME", "Montenegro"],
  ["MG", "Madagascar"],
  ["MK", "Macedonia"],
  ["MT", "Malta"],
  ["MU", "Mauritius"],
  ["MW", "Malawi"],
  ["MX", "Mexico"],
  ["MY", "Malaysia"],
  ["MZ", "Mozambique"],
  ["NA", "Namibia"],
  ["NG", "Nigeria"],
  ["NL", "Netherlands"],
  ["NO", "Norway"],
  ["NP", "Nepal"],
  ["NZ", "New Zealand"],
  ["OM", "Oman"],
  ["PE", "Peru"],
  ["PH", "Philippines"],
  ["PK", "Pakistan"],
  ["PL", "Poland"],
  ["PT", "Portugal"],
  ["QA", "Qatar"],
  ["RE", "Réunion"],
  ["RO", "Romania"],
  ["RS", "Serbia"],
  ["RU", "Russian Federation"],
  ["RW", "Ruanda"],
  ["SA", "Saudi Arabia"],
  ["SB", "Solomon Islands"],
  ["SC", "Seychelles"],
  ["SD", "Sudan"],
  ["SE", "Sweden"],
  ["SG", "Singapore"],
  ["SI", "Slovenia"],
  ["SK", "Slovakia"],
  ["SM", "San Marino"],
  ["SO", "Somalia"],
  ["SY", "Syrian Arab Republic"],
  ["SZ", "Swaziland"],
  ["TH", "Thailand"],
  ["TJ", "Tajikistan"],
  ["TM", "Turkmenistan"],
  ["TN", "Tunisia"],
  ["TR", "Turkey"],
  ["TW", "Taiwan"],
  ["TZ", "Tanzania"],
  ["UA", "Ukraine"],
  ["UG", "Uganda"],
  ["US", "United States of America"],
  ["UZ", "Uzbekistan"],
  ["VE", "Venezuela"],
  ["VN", "Viet Nam"],
  ["VU", "Vanuatu"],
  ["WS", "Samoa"],
  ["XK", "Kosovo"],
  ["YE", "Yemen"],
  ["YT", "Mayotte"],
  ["ZA", "South Africa"],
  ["ZM", "Zambia"],
  ["ZW", "Zimbabwe"],
].map( e => ({ key: e[ 0 ], value: e[ 0 ], text: e[ 1 ], flag: e[ 0 ].toLowerCase() }) )


// WEBPACK FOOTER //
// ./src/pages/checkout/DeliveryPageCoupon.js